/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PersonalAccessTokenLifetime {
    THIRTY_DAYS = 'ThirtyDays',
    NINETY_DAYS = 'NinetyDays',
    ONE_YEAR = 'OneYear',
}
